import { useContext } from "react"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"

function SvgComponent(props: any) {
    const {info: {theme}} = useContext(AppInfoContext)
    
    return (
        <svg
            width={17}
            height={17}
            viewBox="0 0 17 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M6.031 15.877v-5.78c0-.438 0-.657.085-.824a.781.781 0 01.342-.342c.167-.085.386-.085.823-.085H9.47c.437 0 .656 0 .823.085a.781.781 0 01.342.342c.085.167.085.386.085.823v5.781M7.608 1.631l-5.3 4.12c-.353.276-.53.414-.658.587a1.562 1.562 0 00-.248.507c-.058.207-.058.431-.058.88v5.652c0 .875 0 1.313.17 1.647.15.294.389.533.683.683.334.17.772.17 1.647.17h9.062c.875 0 1.313 0 1.647-.17.294-.15.533-.389.683-.683.17-.334.17-.771.17-1.646V7.724c0-.449 0-.673-.058-.88a1.562 1.562 0 00-.248-.507c-.128-.173-.305-.31-.659-.586L9.142 1.63c-.274-.214-.411-.32-.563-.362a.781.781 0 00-.408 0c-.152.041-.289.148-.563.362z"
                stroke={props.isHover ? theme["#0D968F"] : '#A0A0A0'}
                strokeWidth={1.5625}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}
  
  export default SvgComponent